import React, { useEffect, useState, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Button, Row, Col, Spinner, Card, CardBody } from 'react-bootstrap';
import { useAuth, useApiPost, useFetch, useApiDelete } from "../../../hooks";
import { InputField, SelectField, ConfirmModal, SuccessToolbar, ErrorToolbar, SuccessModal } from "../../../lib/formControls";
import { apiUrl } from "../../../lib/appConfig";
import emptyImg from "../../../common/images/emptyImg.png";
import cameraImg from "../../../common/images/cameraImg.png";
import trashIcon from "../../../common/images/trashIcon.png";

const schema = yup.object().shape({
  cameraName: yup.string().required('Camera Name is required'),
  cameraType: yup.string().required('Select the Camera Type'),
  manufacturer: yup.string().required('Manufacturer is required'),
  cameraModel: yup.string().required('Camera Model is required'),
  streamingUrl: yup.string().required('Stream URL/RTSP is required')
});


const CameraForm = ({ mode = 'add', onSubmit, handleAction, initialData = {}, bunkSavedData = {}, loading=false }) => {
  const {
  register,
  handleSubmit,
  watch,
  reset,
  setValue,
  control,
  formState: { errors, isSubmitting }
} = useForm({
  resolver: yupResolver(schema, { context: { mode } }),
  defaultValues: {
    cameraName: '',
    cameraType: '',
    manufacturer: '',
    cameraModel: '',
    streamingUrl: ''
  }
});

  const [actiondisable, setActiondisable] = useState(true);
  const [bunkactiondisable, setBunkactiondisable] = useState(true);
  const [addedcamera, setAddedcamera] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccessmdl, setShowSuccessmdl] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);
  const [customerror, setCustomerror] = useState('');
  const [fetchCameraUrl, setFetchCameraUrl] = useState(null);
  const { authToken } = useAuth();
  const { postData: postCameraData, loading: camereloading, error: cameraerror, responseData: cameraResponse } = useApiPost('camera',authToken);
  const { deleteData, loading: cameredeletloading, error: cameredeleterror } = useApiDelete('camera',authToken);

  const { data: cameraResData, loading: editcameraLoading, error: edcameraError } = useFetch(fetchCameraUrl, authToken);

  useEffect(() => {
    let bunkact = (Object.keys(addedcamera).length>0)?false:true;
    setBunkactiondisable(bunkact);
  }, [addedcamera]);

  const watchCameraName = watch("cameraName");
  const watchCameraType = watch("cameraType");
  const watchManufacturer = watch("manufacturer");
  const watchCameraModel = watch("cameraModel");
  const watchStreamingUrl = watch("streamingUrl");

  useEffect(() => {
    if (watchCameraName || watchCameraType || watchManufacturer || watchCameraModel || watchStreamingUrl) {
      setActiondisable(false);
    }
    if (watchCameraName === '' && watchCameraType === '' && watchManufacturer === '' && watchCameraModel === '' && watchStreamingUrl === '') {
      setActiondisable(true);
    }
  }, [watchCameraName, watchCameraType, watchManufacturer, watchCameraModel, watchStreamingUrl]);

  useEffect(() => {
    /*if (mode === 'edit' && initialData) {*/
    if (initialData) {  
      Object.keys(initialData).forEach((key) => {
        setValue(key, initialData[key]);
      });
    }
  }, [mode, initialData, setValue]);

  useEffect(() => {
      if(bunkSavedData && bunkSavedData?.id !== '' && mode === 'edit') {
        let userUrlTxt = `${apiUrl}camera?filter=entityId|${bunkSavedData?.id}`;
        setFetchCameraUrl(userUrlTxt);
      }
  }, [bunkSavedData]);

  const cameraResDataArr = useMemo(() => {
  if (cameraResData?.data) {
    return cameraResData.data.map((cameraRes) => ({
      id: cameraRes.id,
      cameraName: cameraRes.name,
      cameraType: cameraRes.category,
      manufacturer: cameraRes.manufacturer,
      cameraModel: cameraRes.model,
      streamingUrl: cameraRes.streamingUrl,
    }));
  }
  return [];
}, [cameraResData]);

useEffect(() => {
  if(mode === 'edit' && cameraResDataArr.length>0) {
      setAddedcamera(cameraResDataArr);
  }
}, [cameraResDataArr]);

  const handleDelete = (cameraId) => {
        setShowConfirm(true);
        setSelectedRowId(cameraId);
  };

  const handleConfirm = async () => {
    let payloadObj = { id: selectedRowId };
    let payload = JSON.stringify(payloadObj);
    const { result, error } = await deleteData(payload);
    
    if(error) {
      setCustomerror(error);
    } else {
      setIsDeleted(true);
      setAddedcamera((prev) =>
        prev.filter((camera) => camera.id !== selectedRowId)
      );
    }

    setShowConfirm(false);
    setSelectedRowId('');
  };

  const handleCancel = () => {
    setShowConfirm(false);
    setSelectedRowId('');
  };
  
  const handleSubmitForm = async (data) => {
    console.log('Submitting form data:', data);
    setCustomerror('');
    if(data !== '' && Object.keys(data).length>0) {
          const payloadObj = {
                name: data.cameraName,
                category: data.cameraType,
                manufacturer: data.manufacturer,
                model: data.cameraModel,
                streamingUrl: data.streamingUrl,
                type: 'ip',
                entityId: bunkSavedData?.id,
            };

        let payload = JSON.stringify(payloadObj);

        const { result, error: apiError } = await postCameraData(payload);
        if(result && result?.data && result?.data?.id) {
            setAddedcamera(prevState => [
              ...prevState,
              {
                id:result?.data?.id,
                cameraName: data.cameraName,
                cameraType: data.cameraType,
                manufacturer: data.manufacturer,
                cameraModel: data.cameraModel,
                streamingUrl: data.streamingUrl,
              }
            ]);
            reset();
        } else {
            setCustomerror(apiError);
        }

      }
    /*onSubmit(data);*/
  };

  const handleSuccess = () => {
        setShowSuccessmdl(true);
        setTimeout(()=>{
            handleAction('close-form')
        },1000);
  };

  return (<div className='camera-main-topdiv'>

            <div className='form-header-main'>
                <div className='form-header-row'>
                    <div className='form-header-text'><h6><span onClick={() => handleAction('go-to-incharge')} className='back-arrow-main'><i className='bx bx-arrow-back'></i></span> Camera Configuration (3/3)</h6> </div>
                    <div className='form-header-icon'> <button type="button" onClick={() => handleAction('close-form')} className="btn-close position-absolute end-0 top-0 m-3"></button> </div>
                </div>
            </div>

            {customerror && <ErrorToolbar message={`⚠️ ${customerror}`} />}

           <Row>
            <Col md={6}>
                <form className='d-flex flex-column petrolbunk-commonfromcls camera-from-main' onSubmit={handleSubmit(handleSubmitForm)}>
                    <Row>
                      <Col md={12}>
                        <InputField
                          label="Camera Name"
                          name="cameraName"
                          type="text"
                          placeholder="Camera Name"
                          controlclass="form-custom-group"
                          required={true}
                          register={register}
                          className="custom-input-pd"
                          errors={errors}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <SelectField
                          label="Camera Type"
                          name="cameraType"
                          control={control}
                          options={[
                            { label: 'IN Camera', value: 'in' },
                            { label: 'OUT Camera', value: 'out' }
                          ]}
                          placeholder="Select Camera Type"
                          required={true}
                          errors={errors}
                          className="custom-input-pd form-custom-group"            
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <InputField
                          label="Manufacturer"
                          name="manufacturer"
                          type="text"
                          placeholder="Manufacturer"
                          controlclass="form-custom-group"
                          required={true}
                          register={register}
                          className="custom-input-pd"
                          errors={errors}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <InputField
                          label="Camera Model"
                          name="cameraModel"
                          type="text"
                          placeholder="Camera Model"
                          controlclass="form-custom-group"
                          required={true}
                          register={register}
                          className="custom-input-pd"
                          errors={errors}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <InputField
                          label="Stream URL/RTSP"
                          name="streamingUrl"
                          type="text"
                          placeholder="Stream URL/RTSP"
                          controlclass="form-custom-group"
                          required={true}
                          register={register}
                          className="custom-input-pd"
                          errors={errors}
                        />
                      </Col>
                    </Row>



                    <div className="col-md-12 mt-auto action-btn-buttom-main">
                          <div className="col-md-12 d-flex justify-content-center pb-3">
                                  <Button type="submit" disabled={actiondisable || isSubmitting || loading} variant="primary custom-sbm-btncls add-camere-btn">
                                    {loading ? (
                                      <>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                        {' '}{mode === 'edit' ? 'Updating camera...' : 'Adding camera...'}
                                      </>
                                    ) : (
                                      mode === 'edit' ? 'Add Camera' : 'Add Camera'
                                    )}
                                  </Button>
                          </div>
                          <div className="col-md-12 d-flex justify-content-between pt-3 action-btn-buttomdiv">
                                  <Button disabled={actiondisable} variant="secondary custom-cnl-btncls" type="button" onClick={() => reset()}>
                                    Reset
                                  </Button>
                                  <Button type="button" disabled={bunkactiondisable} variant="primary custom-sbm-btncls" onClick={() => handleSuccess()}>
                                   {(mode === 'edit') ? "Update Bunk" : "Add Bunk"}
                                  </Button>
                          </div>
                    </div>
                    
                  </form>
            </Col>
            <Col md={6}>
                <Card className='p-1 camera-card'>
                      <CardBody className="p-4">
                          <div className='added-camera-list'>
                                <div className='form-header-main'>
                                    <div className='form-header-row'>
                                        <div className='form-header-text'><h6>Cameras Added</h6> </div>
                                        <div className='form-header-icon'></div>
                                    </div>
                                </div>
                                {(Object.keys(addedcamera).length>0) ? <div className='added-camera-body'>
                                      <div className='added-camera-inner'>
                                        {addedcamera.map((camera) => {
                                          return (<Row>
                                                  <Col xs={6} sm={2} md={2} className='order-1'><div className='added-camera-icon'><img src={cameraImg} alt='nrd' /></div></Col>
                                                  <Col xs={6} sm={2} md={2} className="order-2 order-sm-3 text-end">
                                                      <div className='camera-delete-icon'>
                                                          <img src={trashIcon} alt='trs' onClick={() => handleDelete(camera.id)} />
                                                      </div>
                                                  </Col>
                                                  <Col xs={12} sm={8} md={8} className="order-3 order-sm-2">
                                                      <div className='added-camera-info'>
                                                            <h6>{camera.cameraName} {(camera.cameraType === 'in')?<span className='added-incamera'>IN Camera</span>:<span className='added-outcamera'>OUT Camera</span>}</h6>
                                                            <p>{camera.manufacturer} / {camera.cameraModel}</p>
                                                            <p className='camera-url'>{camera.streamingUrl}</p>
                                                      </div>
                                                  </Col>
                                                  
                                          </Row>)
                                        })}
                                      </div>
                                </div> : <div className='norecord-div'>
                                      <div className='norecord-info'>
                                        <img src={emptyImg} alt='nrd' />
                                        <p>No data found</p>
                                      </div>
                                </div>}
                                
                          </div>
                      </CardBody>
                </Card>
            </Col>
           </Row> 

           <ConfirmModal
              show={showConfirm}
              onHide={handleCancel}
              onConfirm={handleConfirm}
              title={<span className='confirm-mdltitle-iconmain'><i className="bx bx-trash"></i></span>}
              message="Are you sure you want to delete this camera?"
              btntxt="Delete Now"
            />

            <SuccessModal
              show={showSuccessmdl}
              message={(mode === 'edit') ? "Bunk updated successfully!" : "Bunk added successfully!"}
            />
    
  </div>);
};

export default CameraForm;
